module.exports = __webpack_public_path__ + "static/media/Logo_Lantier.bf4faf93.jpg";